
















































































































































































































































































/*
  getProjectMsg 获取项目信息管理分页列表
  saveOrUpdate 保存或编辑项目信息
  deleteProjectMsg 删除项目信息
*/
import { Vue, Component } from "vue-property-decorator";
//引入接口调用函数
import {
  getProjectMsg,
  saveOrUpdate,
  deleteProjectMsg,
  getParam
} from "../../../api/projectManage";
import { Form as ElForm } from "element-ui";
import { ruleNormal, rulePattern } from "../../../utils/common";
import importAndExportMixin from "../../../mixins/importAndExport";
import moment from "moment";

@Component({
  name: "projectManage",
  mixins: [importAndExportMixin],
  components: {
    UploadProgress: () => import("@/components/UploadProgress/index.vue"),
  },
})
export default class extends Vue {
  private project: string = ""; //项目编号或名称
  private year: string = ""; //年份
  private showTableLoading: boolean = false; //是否显示列表loading
  private tableData: object[] = [{ propXXX: "XXX" }]; //列表数据
  private pageNo: number = 1; //当前页码
  private pageSize: number = 10; //当前条目
  private subjectId11: string = ""; //科目
  private total: number = 0; //总条数
  private chooseIdArray: string[] = []; //勾选的数据id集合
  private dialogFormVisible: boolean = false; //是否显示添加\编辑弹窗
  private editType: string = ""; //记录是 "添加" 还是 "修改"
  private editForm: object = {}; //添加\编辑弹窗的数据
  private dialogFormTitle: string = ""; //弹窗标题
  private fullscreenLoading: boolean = false; //spin的显示
  private tableHeight: number = 0;
  private subjects: object[] = []; //“来源”数组
  private uploadData = {progressId: -1}; // 文件上传入参
  public $refs!: {
    table: HTMLFormElement;
    editForm: ElForm;
  };
  private editFormRules: object = {
    projectYear: ruleNormal("请选择项目年份"),
    projectCode: [
      ruleNormal("请输入项目编号"),
      rulePattern(/^[0-9A-Za-z]{0,12}$/, "请输入12位以内的数字或字母")
    ],
    subjectId: ruleNormal("请选择科目"),
    projectName: ruleNormal("请输入项目名称"),
    startTime: ruleNormal("请选择开始时间"),
    endTime: ruleNormal("请选择结束时间"),
    projectAbbre: ruleNormal("请输入项目简称")
  };
  private goToInfo: Array<Object> = [
    { name: "导入教师", path: "teacherInfoManage" },
    { name: "开始选拔", path: "/marking/markingTeacherChoose" },
    { name: "正式聘用", path: "/marking/markingEmployManage" },
    { name: "导入质量", path: "/marking/markingQualityManage" },
    { name: "开始评价", path: "/marking/markingTeacherEvaluate" }
  ]; // 存储项目操作path信息
  created() {
    //获取页面参数
    this.getParams();
    //获取列表
    this.getData();
  }

  mounted() {
    setTimeout(() => {
      this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 80;
      if (this.tableHeight < 300) { this.tableHeight = 300; }
    }, 100);
  }

  //列表接口和导出接口的传参
  private getRequestParams() {
    return {
      current: this.pageNo, //当前页
      size: this.pageSize, //记录数
      projectNameOrCode: this.project, //项目编号或名称
      projectYear: this.year //项目年份
    };
  }

  //上传地址
  get uploadUrl() {
    return window.config.baseUrl4Shool + "/baseinfo/projectMsgManage/import";
  }
//获取页面参数
  private async getParams() {
    try {
      let res = await getParam();
      console.log(res);
      this.subjects = res.data.subjects;
    } catch (error) {
      this.showTableLoading = false;
      this[`$message`]({
        type: "error",
        message: error!.mesg ? error!.mesg : error
      });
    }
  }
  //获取列表数据
  private async getData() {
    this.showTableLoading = true;
    try {
      let res = await getProjectMsg(this.getRequestParams());
      this.showTableLoading = false;
      this.tableData = res.data.records;
      this.total = res.data.total;
    } catch (error) {
      this.showTableLoading = false;
      // this.$message.error(error || "获取数据失败");
      this[`$message`]({
        type: "error",
        message: error!.mesg ? error!.mesg : error
      });
    }
  }

  // 根据分页计算页码
  private indexMethod(index) {
    return index + 1 + (this.pageNo - 1) * this.pageSize;
  }

  //搜索查询
  private searchHandle() {
    this.pageNo = 1;
    this.getData();
  }

  //勾选处理
  private selectChangeHandle(v: object[]) {
    this.chooseIdArray = v.map((item: any) => {
      return item.projectId;
    });
  }

  //点击“添加”或“编辑”弹窗处理
  private dialogFormVisibleDialog(type, row) {
    //记录是“添加”还是“修改”
    this.editType = type;
    this.dialogFormTitle = type === "add" ? "添加考试项目" : "编辑考试项目";
    if (row) {
      console.log("21212",row);
      //获取弹窗数据对象
      this.editForm = {
        projectAbbre: row.projectAbbre, //项目简称
        projectCode: row.projectCode, //项目编号
        projectId: row.projectId, //项目id
        subjectId: row.projectSubject?row.projectSubject.split(","):[], //科目
        projectName: row.projectName, //项目名称
        projectIsPersonal: row.projectIsPersonal, // 是否私有
        projectYear: String(row.projectYear), //项目年份
        // startTime: String(row.startTime), //开始时间
        remark: row.remark //备注
      };
      console.log("2121212",this.editForm)
    } else {
      //获取弹窗数据对象
      this.editForm = {
        projectIsPersonal: '0'
      };
    }
    //显示弹窗
    this.dialogFormVisible = true;
  }

  //带参数进行路由跳转
  private goToPath(path, row) {
    this.$router.push({
      path: path,
      query: {
        projectId: row.projectId,
        projectLabel: row.projectYear + " - " + row.projectName
      }
    });
  }

  //添加\编辑-保存的处理
  private saveEditHandle() {
    this.$refs.editForm.validate(async (valid: boolean) => {
      if (valid) {
        try {
          this.fullscreenLoading = true;
          await saveOrUpdate(this.editForm);
          this.fullscreenLoading = false;
          this.$message.success("保存成功");
          //关闭弹窗
          this.dialogFormVisible = false;
          //刷新列表
          this.getData();
          (this.$refs.editForm as ElForm).clearValidate();
        } catch (error) {
          this.fullscreenLoading = false;
          // this.$message.error(error || "保存失败");
          this[`$message`]({
            type: "error",
            message: error!.mesg ? error!.mesg : error
          });
        }
      }
    });
  }
  // 取消
  private handleCancel() {
    (this.$refs.editForm as ElForm).clearValidate();
    this.dialogFormVisible = false;
  }
  private dateFormat(row, column) {
    var date = row[column.property];
    if (date == undefined) {
      return "";
    }
    return moment(date).format("YYYY-MM-DD HH:mm:ss");
  }
  //删除处理
  private deleteHandle() {
    if (this.chooseIdArray.length <= 0) {
      this.$message.warning("请先勾选！");
      return;
    }
    //询问是否删除
    this.$confirm("确定删除?", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning"
    }).then(async () => {
      try {
        await deleteProjectMsg(this.chooseIdArray);
        this.$message.success("删除成功");
        //操作成功，重新获取列表
        this.getData();
      } catch (error) {
        // this.$message.error(error || "删除失败");
        this[`$message`]({
          type: "error",
          message: error!.mesg ? error!.mesg : error
        });
      }
    });
  }

  // 每页条目变化时
  private handleSizeChange(val: number): void {
    this.pageSize = val;
    this.getData();
  }
  // 当前页发生改变时
  private handleCurrentChange(val: number): void {
    this.pageNo = val;
    this.getData();
  }
}
